import { getHeight } from '@/lib/dom/getHeight'
import { setHeight } from '@/lib/dom/setHeight'
import { ready } from '@/lib/ready'

// 初始化 onsale_skuwish 模块高度
ready(() => {
  document
    .querySelectorAll('.has-product .product-list')
    .forEach((x, index: number) => {
      const productBox = x as HTMLElement
      const elClasses = ['.product-name', '.product-icon', '.product-review']
      elClasses.forEach((elClass) => {
        const els = productBox.querySelectorAll(elClass)
        const maxHeight = Math.max(...Array.from(els).map((el) => getHeight(el)))
        els.forEach((el) => {
          const element = el as HTMLElement
          setHeight(element, maxHeight)
        })
      })
    })
})
